/**
 * MaleHealthTwinPage — мъжкият близнак (T:E2, простато-метаболитна ос).
 * iter1030 — изнесен от таблото, за да не претоварва началния екран.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";
import SEO from "@/components/SEO";
import MaleHealthTwinPanel from "@/components/male_health/MaleHealthTwinPanel";
import SemenAnalysisCard from "@/components/male_health/SemenAnalysisCard";
import { twinLabel } from "@/lib/twinCatalog";

import { MobileTopBar } from "@/components/MobileTopBar";
export default function MaleHealthTwinPage() {
  const { isDark } = useTheme();
  return (
    <div className={`min-h-screen ${isDark ? "bg-[hsl(222,47%,6%)] text-white" : "bg-[#F8FAFC] text-[#1A1A2E]"}`}
      data-testid="male-health-twin-page">
      <MobileTopBar title="Мъжко здраве" fallbackTo="/dashboard" testid="male_health-twin-mobile-topbar" />
      <SEO title="Мъжки Health Twin" description="T:E2, простато-метаболитна ос и ароматаза." path="/dashboard/male-health-twin" />
      <div className="max-w-5xl mx-auto px-4 py-6">
        <Link to="/dashboard" className="inline-flex items-center gap-1 text-xs font-bold opacity-70 hover:opacity-100"
          data-testid="male-twin-back">
          <ArrowLeft className="w-3.5 h-3.5" /> Към таблото
        </Link>
        <h1 className="mt-3 text-2xl sm:text-3xl font-extrabold">{twinLabel("male_health")}</h1>
        <p className="text-sm opacity-70 mt-1 max-w-2xl">
          Съотношението тестостерон/естрадиол, простато-метаболитната ос и
          ароматазата — образователен изглед върху твоите данни.
        </p>
        <div className="mt-4">
          <MaleHealthTwinPanel />
        </div>
        <div className="mt-4">
          <SemenAnalysisCard isDark={isDark} />
        </div>
      </div>
    </div>
  );
}
